module.exports = __webpack_public_path__ + "static/media/45.36ace02c.png";